import { DivTooltip, ProgressBar as ProgressBarUIKit } from '@wg/wows-react-uikit';
import { useDispatch } from 'react-redux';

import { resetSearch } from '~/Actions/ActionCategory';
import { filterItemsByUniqueType } from '~/Actions/ActionFilter';
import { UNIQUE_TYPES } from '~/Actions/ActionFilterTypes';
import DefaultTooltip from '~/Components/Tooltip/DefaultTooltip';
import { isAuthorizedUser } from '~/config/user';
import { playTabClickSound } from '~/helpers/audioApi';
import { DWH_EVENTS } from '~/helpers/consts';
import dwhExport from '~/helpers/dwhExport';
import { t } from '~/helpers/localization';
import { ICategories } from '~/interfaces';
import { COMMON_TYPES, UNIQUE_TYPE } from '~/settings/filters';

import styles from './ProgressBar.scss';

interface IProgressBar {
    category: ICategories;
    availableAwardsCount: number;
    totalCount: number;
    uniqueAwardsCount: number;
}

const ProgressBar = (props: IProgressBar) => {
    const dispatch = useDispatch();
    const _isAuthorizedUser = isAuthorizedUser();

    const getProgressPercent = () => {
        const { availableAwardsCount, totalCount } = props;

        if (totalCount === 0) {
            return totalCount;
        }

        return Math.ceil((availableAwardsCount * 100) / totalCount) / 100;
    };

    const changeTypeDisplayFilter = (type: UNIQUE_TYPES) => {
        playTabClickSound();
        dwhExport.send(DWH_EVENTS.APPLY_PRESET, { category: props.category, preset_name: type.toLowerCase() });
        dispatch(resetSearch());
        dispatch(filterItemsByUniqueType(props.category, type));
    };

    return (
        <div className={styles.progressWrap}>
            <div className={styles.progressCollectedInfo}>
                <div className={styles.text}>{_isAuthorizedUser ? t('Собрано:') : t('Всего:')}</div>
                <div className={styles.collectedInfo}>
                    {_isAuthorizedUser ? (
                        <span className={styles.cursor} onClick={changeTypeDisplayFilter.bind(this, COMMON_TYPES)}>
                            {props.availableAwardsCount}/{props.totalCount}
                        </span>
                    ) : (
                        props.totalCount
                    )}
                    {!!parseInt(props.uniqueAwardsCount.toString(), 10) && (
                        <span className={styles.exclusiveCounterWrap} onClick={changeTypeDisplayFilter.bind(this, UNIQUE_TYPE)}>
                            <DivTooltip
                                tooltipBody={
                                    <DefaultTooltip
                                        text={t('Категория "Дополнительные" включает необычные или авторские предметы, которые не учитываются в прогрессе сбора коллекции.')}
                                        footer={t('Показать')}
                                    />
                                }
                            >
                                <span className={styles.unique}>
                                    &nbsp;<span className={styles.plus}>+</span> {t('Дополнительные:')} {props.uniqueAwardsCount}
                                </span>
                            </DivTooltip>
                        </span>
                    )}
                </div>
            </div>
            <ProgressBarUIKit size={'large'} completed={getProgressPercent()} color={'#ffcc65'} />
        </div>
    );
};

export default ProgressBar;
